import { Component, OnInit } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource, MatTreeFlattener } from '@angular/material/tree';
import { DataService } from 'app/data.service';

declare const $: any;

declare interface RouteHolder {
  name: string;
  icon: string;
  path?: string;
  links?: RouteHolder[];
}

export const ROUTES_DIV: RouteHolder[] = [
  { name: 'Dashboard', icon:'dashboard', links: [
    { path: 'dashboard', name: 'Dashboard',  icon: 'dashboard'}
  ]},
  { name: 'Properties' , icon:'language', links:[
    { path: 'view-properties', name: 'View Properties', icon: 'view_list'},
  ]},
  { name: 'State' , icon:'language', links:[
    { path: 'state/add', name: 'Add State', icon: 'language'},
    { path: 'state/view', name: 'View States', icon:'language'},
  ]},
  { name: 'District' , icon:'explore', links:[
    { path: 'district/add', name: 'Add Districts', icon: 'explore'},
    { path: 'district/view', name: 'View Districts', icon: 'explore'},
  ]},
  { name: 'Municipality' , icon:'navigation', links:[
    { path: 'municipality/add', name: 'Add Municipality', icon: 'navigation'},
    { path: 'municipality/view', name: 'View Municipalities', icon: 'navigation'}
  ]},
  { name: 'Users' , icon:'account_circle', links:[
    { path: 'users/view', name: 'View Users', icon: 'account_circle'},
  ]},
  { name: 'Advertisement Plans' , icon:'shopping_cart', links:[
    { path: 'ad-plans/add', name: 'Add New Plan', icon: 'shopping_cart'},
    { path: 'ad-plans/view', name: 'View Ad Plans', icon: 'shopping_cart'},
  ]},
  { name: 'Property Types' , icon:'web', links:[
    { path: 'property-type/add', name: 'Add New Type', icon: 'web'},
    { path: 'property-type/view', name: 'View Property Types', icon: 'web'},
  ]},
  { name: 'Blogs' , icon:'rss_feed', links:[
    { path: 'blog/add', name: 'Add New Blog', icon: 'rss_feed'},
    { path: 'blog/view', name: 'View Blogs', icon: 'rss_feed'},
  ]},
  { name: 'Local Ads & Road Block' , icon:'shop', links:[
    { path:'road-block', name: 'Road Block Ads', icon:'add_road'},
    { path:'local-ad', name: 'Local Ads', icon:'ad_units'},
  ]},
  { name: 'Payments' , icon:'shop', links:[
    { path:'verify-transaction', name: 'Wire Transfer', icon:'swap_horiz'},
    { path:'verify-bank-voucher', name: 'Bank Deposit', icon:'account_balance'},
    { path:'esewa', name: 'eSewa Transfer', icon:'swap_horiz'},
    { path:'cash-payments', name: 'Cash Payments', icon:'money'}
  ]},
  { name: 'Banner Image' , icon:'shop', links:[
    { path:'banner-image', name: 'View Banner Images', icon:'view_carousel'}
  ]}
]

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  menuDivs: any[];

  treeControl = new NestedTreeControl<RouteHolder>(node => node.links);

  dataSource = new MatTreeNestedDataSource<RouteHolder>();

  constructor( private adminService: DataService ) {
    this.dataSource.data = ROUTES_DIV;
  }

  transactionCount: number = 0

  voucherCount: number = 0

  totalTransaction: number = 0

  hasChild = (_: number, node: RouteHolder) => !!node.links && node.links.length > 0;

  ngOnInit( ) {
    this.adminService.getTransactions().subscribe(data => {
      let payments = data.transactions
      if(payments.length > 0){
        for(let payment of payments){
          if(!payment.status){
            this.transactionCount++
          }
        }
        this.totalTransaction = this.totalTransaction + this.transactionCount
      }
    })
    this.adminService.getBankVouchers().subscribe(data => {
      let payments = data.bankPayments
      if(payments.length > 0){
        for(let payment of payments){
          if(!payment.status){
            this.voucherCount++
          }
        }
        this.totalTransaction = this.totalTransaction + this.voucherCount
      }
    })
  }

  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  };
}
